import React from 'react';

export const Marquee = () => {
  return (
    <div className="bg-simba-green py-4 overflow-hidden relative">
      <div className="flex animate-marquee whitespace-nowrap">
        {[...Array(10)].map((_, i) => (
          <div key={i} className="flex items-center mx-4">
            <span className="text-simba-lime/20 font-display font-bold text-4xl uppercase tracking-widest opacity-50">
              Natural • Potent • Organic • Vitality • Strength •
            </span>
          </div>
        ))}
      </div>
      
      {/* Absolute gradient fade for edges */}
      <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-simba-green to-transparent z-10"></div>
      <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-simba-green to-transparent z-10"></div>
    </div>
  );
};
